var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00664F",
  d: "M28 5.765v20.47A1.764 1.764 0 0 1 26.235 28H5.765A1.765 1.765 0 0 1 4 26.235V5.765A1.765 1.765 0 0 1 5.765 4h20.47A1.765 1.765 0 0 1 28 5.765m-16.941 7.412h-3.53V24.47h3.53zm.318-3.883a2.033 2.033 0 0 0-2.02-2.047h-.063a2.047 2.047 0 1 0 0 4.094 2.035 2.035 0 0 0 2.082-1.983zM24.47 17.61c0-3.395-2.16-4.715-4.306-4.715a4.02 4.02 0 0 0-3.572 1.821h-.099v-1.538h-3.317V24.47h3.529v-6.007a2.344 2.344 0 0 1 2.117-2.527h.135c1.122 0 1.955.705 1.955 2.484v6.05h3.53z"
})));
export default SvgLinkedin;